import type { Firestore, Unsubscribe } from "firebase/firestore";
import { doc, getDoc, onSnapshot, setDoc } from "firebase/firestore";

export type IngredientLots = Record<string, string>;

const COLLECTION = "ingredient-lots";
const DOCUMENT = "current";

export class IngredientLotsRepository {
  private firestore: Firestore;

  constructor(firestore: Firestore) {
    this.firestore = firestore;
  }

  private get document() {
    return doc(this.firestore, COLLECTION, DOCUMENT);
  }

  async getLots(): Promise<IngredientLots> {
    const snapshot = await getDoc(this.document);
    return (snapshot.data() as IngredientLots) ?? {};
  }

  async saveLots(lots: IngredientLots): Promise<void> {
    await setDoc(this.document, lots);
  }

  trackLots(onChange: (lots: IngredientLots) => void): Unsubscribe {
    return onSnapshot(this.document, (snapshot) => {
      onChange((snapshot.data() as IngredientLots) ?? {});
    });
  }
}
